import { RpcService } from 'rpc';
export const svc = new RpcService({
    transport: 'WEBSOCKET',
    envelope: 'JSON-RPC-2.0',
    strictParameters: false,
    target: `${window.hcstatic.portal_url}/@@learningpath.rpc`,
    services: {
        get_versions: {
            parameters: [
                {
                    name: 'versionbase',
                    type: 'string',
                    optional: false
                }
            ]
        },
        get_latest_version: {
            parameters: [
                {
                    name: 'versionbase',
                    type: 'string',
                    optional: false
                }
            ]
        },
        get_parenttree: {
            parameters: [
                {
                    name: 'version',
                    type: 'string',
                    optional: false
                },
                {
                    name: 'language',
                    type: 'string',
                    optional: false
                }
            ]
        },
        get_root: {
            parameters: [
                {
                    name: 'rootname',
                    type: 'string',
                    optional: false
                },
                {
                    name: 'version',
                    type: 'string',
                    optional: false
                },
                {
                    name: 'language',
                    type: 'string',
                    optional: false
                }
            ]
        },
        get_topic_roots: {
            parameters: [
                {
                    name: 'version',
                    type: 'string',
                    optional: false
                },
                {
                    name: 'language',
                    type: 'string',
                    optional: false
                }
            ]
        },
        get_topic: {
            parameters: [
                {
                    name: 'topicname',
                    type: 'string',
                    optional: false
                },
                {
                    name: 'version',
                    type: 'string',
                    optional: false
                },
                {
                    name: 'language',
                    type: 'string',
                    optional: false
                }
            ]
        },
        related_topics: {
            parameters: [
                {
                    name: 'topicid',
                    type: 'string',
                    optional: false
                },
                {
                    name: 'version',
                    type: 'string',
                    optional: false
                },
                {
                    name: 'language',
                    type: 'string',
                    optional: false
                }
            ]
        },
        get_images: {
            parameters: [
                {
                    name: 'version',
                    type: 'string',
                    optional: false
                },
                {
                    name: 'language',
                    type: 'string',
                    optional: false
                }
            ]
        },
        quiz_list: {
            parameters: []
        }
    }
});
export default svc;
